/* eslint-disable */
const state = {
    selection: { 
        id: 1,
        type: null,
        resetData: false,
        emptySelection: false,
        callback: null,
    },
    formModel: null,
  };
  
  const actions = {
    selectComp({ commit }, { id, type, resetData, emptySelection, callback}) {
      commit("selectComp", { id, type, resetData, emptySelection, callback });
      
    },
    updateFormModel({commit}, {formModel, callback}) {
      commit("updateFormModel", { formModel });
      if(typeof callback === 'function') {
        callback();
      }
    },
  };
  
  const mutations = {
    selectComp(state, { id, type, resetData, emptySelection, callback }) {
      state.selection = { 
          id: id,
          type: type,
          resetData: resetData,
          emptySelection: emptySelection,
          callback: callback
        };
    },
    updateFormModel(state, { formModel }){
      state.formModel = formModel
    },
  };
  
  export const appBar = {
    namespaced: true,
    state,
    actions,
    mutations,
  };
  